import type { BackendGenerationToolEnum, BackendProject } from 'src/types/backend';

// The Blog Wizard panel suggests a title and an outline before its first Generate. These runs hold no
// content, so they do not describe a project that has no assets yet.
const BLOG_WIZARD_PANEL_TOOLS: string[] = [
  'dd_blog_post_title',
  'dd_blog_post_outline',
] satisfies BackendGenerationToolEnum[];

// Both lists reach the row, and the assets a project holds describe it better than what it was
// generated with — the generated tools only stand in while it holds no assets of its own.
export const getProjectAssetTools = (
  project: Pick<BackendProject, 'assetsGenerationTools' | 'generatedGenerationTools'>
): string[] => {
  if (project.assetsGenerationTools?.length) {
    return project.assetsGenerationTools;
  }

  return (project.generatedGenerationTools ?? []).filter(
    (tool) => !BLOG_WIZARD_PANEL_TOOLS.includes(tool)
  );
};
